import logo from '../assets/images/logo.png';

const Images = {
  LOGO: logo,
};

export default Images;
